module.exports = {
	"name": "hysdk",
	"version": "1.2.7",
	"description": "Hy SDK",
	"author": [
		"adwon.lin",
		"changquan.fang"
	],
	"email": "adwon.lin@qunar.com",
	"repository": {
		"type": "git",
		"url": "git@gitlab.corp.qunar.com:mfe/hysdk.git"
	},
	"license": "MIT",
	"devDependencies": {
		"babel-core": "^6.18.2",
		"babel-loader": "^6.2.8",
		"babel-preset-es2015": "^6.24.1",
		"cpr": "^2.0.0",
		"css-loader": "^0.26.0",
		"style-loader": "^0.13.1",
		"ydoc": "^3.0.0"
	}
};


//////////////////
// WEBPACK FOOTER
// ../package.json
// module id = 30
// module chunks = 0 2 4